/**
 * author: Donlin.lee
 * time: 20201216
 **/
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import '@/assets/styles/components/order-confirm.scss'
import OrderConfirmStatus from './OrderConfirmStatus'
import { getSafe } from '@/helpers/global';
// import PIN from '../PIN/PIN';
import { openOrderCancelDialog, openOrderModifyDialog, openOTPDialog,openOrderFeesDialog } from '@/actions/app';
import { orderActions } from '@/actions/trading';
import { SERVICES_RESP } from '@/configurations';
import { PARAMS } from '@/constants/params';
import { formatFunctions } from '../../helpers/functions';
import { dataType } from '@/constants/data-type';
import { ORDER_MODE, ORDER_TYPE } from "@/constants/app";
import Tips from '../Tips/Tips';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';
import { tipsType } from '@/constants/tips-type';
import { Number } from 'es6-shim';

class OrderConfirm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSend: false,
      orderTable: [],
      orderResult: {},
      stockName:'',
      isResubmit:'N',
      isResubmitReasonList:[],
      loading:false,
      feeAmt:'',
      feesList:[]
    }
  }

  placeOrder = () => {
    const { language, data, currentTradingAccount } = this.props;
    const params = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq + '',
      [PARAMS.MARKET_ID]: data.marketID,
      [PARAMS.INSTRUMENT_ID]: data.instrumentID,
      [PARAMS.BS]: data.isBuy ? 'B' : 'S',
      [PARAMS.ORDER_TYPE]: data.orderType.value,
      [PARAMS.QTY]: data.quantity + '',
      [PARAMS.PRICE]: data.price + '',
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.IS_RESUBMIT]:this.state.isResubmit
    }
    if (data.goodTillDate) {
      params[PARAMS.GOOD_TILL_DATE] = data.goodTillDate.value
    }
    if(data.orderType.value === ORDER_TYPE.TRIGGER_ORDER.value) {
      params[PARAMS.STOP_TYPE] = data.stopType.value;
      params[PARAMS.STOP_PRICE] = data.stopPrice + '';
    }
    this.setState({
      isResubmit:'N',
      isResubmitReasonList:[],
      loading:true
    })
    this.props.placeOrderAction(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        // if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({ orderResult: res.result })
        // }
      }
      if(res.result.errorCode === SERVICES_RESP.SUCCESS_CODE){
        if(res.result.isSuccess === 'N'){
          const reasonsList = res.result.reasonsList;
          let reasons = [];
          let needResubmit = false;
          for (let i = 0; i < reasonsList.length; i++) {
            const item = reasonsList[i];
            if(item.action === 'W'){
              reasons.push(item.reason);
              needResubmit = true;
            }else if(item.action === 'I'){
              needResubmit = true;
            }else{
              reasons.splice(0,reasons.length);
              needResubmit = false;
              break;
            }
            this.setState({loading:false})
          }
          if(needResubmit){
            this.setState({
              isResubmit:'Y'
            },() => {
              if(reasons.length > 0){
                this.setState({
                  isResubmitReasonList:reasons
                }) 
              }
            })
          }
        }
      }
      if(this.state.isResubmit !== 'Y'){
        const el = document.getElementById('dialog_title');
        if (el) {
          const { language } = this.props;
          el.innerHTML = language.order_result;
        }
        if (this.props.isMobile) {
          this.props.cb(res)
          this.props.onClose()
        } else {
          this.setState({ isSend: true, loading:false })
          this.props.onHasResult();
        }
      }
    })
  }

  modifyOrder = () => {
    const { language, data, currentTradingAccount, isMobile } = this.props;
    const params = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq + '',
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.ORDER_GROUP_ID]: data.orderGroupID,
      [PARAMS.ORDER_ID]: data.orderID,
      [PARAMS.NEW_PRICE]: data.newPrice + '',
      [PARAMS.NEW_QTY]: data.newQTY + '',
      [PARAMS.IS_RESUBMIT]: this.state.isResubmit
    }
    this.setState({
      isResubmit:'N',
      isResubmitReasonList:[],
      loading:true,
      isSubmit:false,
    })
    this.props.modifyOrder(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        // if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          if(res.result.isSuccess === 'N'){
            const reasonsList = res.result.reasonsList;
            let reasons = [];
            let needResubmit = false;
            for (let i = 0; i < reasonsList.length; i++) {
              const item = reasonsList[i];
              if(item.action === 'W'){
                reasons.push(item.reason);
                needResubmit = true;
              }else if(item.action === 'I'){
                needResubmit = true;
              }else{
                reasons.splice(0,reasons.length);
                needResubmit = false;
                break;
              }
              this.setState({ loading:false })
            }
            if(needResubmit){
              this.setState({
                isResubmit:'Y'
              },() => {
                if(reasons.length > 0){
                  this.setState({
                    isResubmitReasonList:reasons
                  }) 
                }
              })
            }
          }
          if(this.state.isResubmit !== 'Y'){
            const orderResult = {
              ...this.props.data,
              ...res.result,
              isSuccess: res.result.isSuccess,
              orderID: this.props.data.orderID,
              inputTime: this.props.data.inputTime,
              newPrice: params[PARAMS.NEW_PRICE],
              newQty: params[PARAMS.NEW_QTY],
              feesList: this.state.feesList,
              feeAmt: this.state.feeAmt ? this.state.feeAmt : res.result.feeAmt
            }
            this.setState({
              orderResult,
              isSend: true,
            },() => {
              const { language } = this.props;
              const el = document.getElementsByTagName('p');
              if (el) {
                for (let i = 0; i < el.length; i++) {
                  if(el[i].innerText===language.order_confirm_title){
                    el[i].innerText = language.order_result
                  }
                }
              }
              this.props.onHasResult()
            })
          }
        // }
      }
      this.setState({
        loading: false
      })
    })
  }

  closeDialog = (isCloseDialog) => {
    this.props.cb(isCloseDialog)
    this.props.onClose()
  }

  handleConfirm = () => {
    // openOTPDialog(this.handleGetOTPCode)
    if(this.props.data.isModifyOrder === 'Y'){
      this.modifyOrder()
    }else{
      this.placeOrder()
    }
  }

  handleGetOTPCode = (otpCode) => {
    if (otpCode) {
      this.placeOrder()
    }
  }

  mappingOrderData = data => {
    const { language, currentTradingAccount } = this.props
    const { feeAmt } = this.state;
    if(data.isModifyOrder && data.isModifyOrder === 'Y'){
      const orderTable =[
        {
          label: 'place_order_dialog_cash_account',
          value: currentTradingAccount.clientID
        },
        {
          label: 'common_order_type',
          value: language[`order_type_${data.orderType.toLowerCase()}`]
        },
        {
          label: 'order_original_price',
          value: `${data.currencyID} ${formatFunctions.dataFormat(data.price, dataType.CURRENCY)}`
        },
        {
          label: 'order_new_price',
          value: `${data.currencyID} ${formatFunctions.dataFormat(data.newPrice, dataType.CURRENCY)}`
        },
        {
          label: 'common_trigger_type',
          value: data.stopType ? language[data.stopType.label] : '-'
        },
        {
          label: 'common_trigger_price',
          value: data.stopPrice ? `${data.currencyID} ${formatFunctions.dataFormat(data.stopPrice, dataType.CURRENCY)}` : '-'
        },
        {
          label: 'order_original_quantity',
          value: `${formatFunctions.dataFormat(data.qty, dataType.NUMBER)} ${language.common_share.format(
            language.lang === 'en_US' && data.qty > 1 ? 's' : ''
          )}`
        },
        {
          label: 'order_new_quantity',
          value: `${formatFunctions.dataFormat(data.newQTY, dataType.NUMBER)} ${language.common_share.format(
            language.lang === 'en_US' && data.newQTY > 1 ? 's' : ''
          )}`
        },
        {
          label: 'common_good_till_date',
          value: data.goodTillDate ? data.goodTillDate.value : '-'
        }
      ]
      this.setState({ orderTable })
    }else{
      const orderTable = [
        {
          label: 'place_order_dialog_cash_account',
          value: data.cashAccount.label ? data.cashAccount.label : data.cashAccount  ? data.cashAccount : '-'
        },
        {
          label: 'common_order_type',
          value: language[`order_type_${data.orderType.value.toLowerCase()}`]
        },
        {
          label: 'common_price',
          value: `${data.currencyID} ${formatFunctions.dataFormat(data.price, dataType.CURRENCY)}`
        },
        {
          label: 'common_trigger_type',
          value: data.stopType ? language[data.stopType.label] : '-'
        },
        {
          label: 'common_trigger_price',
          value: data.stopPrice ? `${data.currencyID} ${formatFunctions.dataFormat(data.stopPrice, dataType.CURRENCY)}` : '-'
        },
        {
          label: 'common_quantity',
          value: `${formatFunctions.dataFormat(data.quantity, dataType.NUMBER)} ${language.common_share.format(
            language.lang === 'en_US' && data.quantity > 1 ? 's' : ''
          )}`
        },
        {
          label: 'common_good_till_date',
          value: data.goodTillDate ? data.goodTillDate.value : '-'
        }
      ]
      this.setState({ orderTable })
    }
  }

  getCommissionAndFees = () => {
    const {language, currentTradingAccount, data} = this.props;
    const {clientID, tradingAccSeq} = currentTradingAccount;
    let params = {};
    if(data.isModifyOrder && data.isModifyOrder === 'Y'){
      const {marketID, instrumentID, bs, newPrice, newQTY} = data;
      params = {
        [PARAMS.CLIENT_ID]: clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: clientID,
        [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.MARKET_ID]:marketID,
        [PARAMS.INSTRUMENT_ID]:instrumentID,
        [PARAMS.BS]:bs,
        [PARAMS.PRICE]: String(newPrice),
        [PARAMS.QTY]:String(newQTY)
      }
    }else{
      const {marketID, instrumentID, isBuy, price, quantity} = data;
      params = {
        [PARAMS.CLIENT_ID]: clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: clientID,
        [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.MARKET_ID]:marketID,
        [PARAMS.INSTRUMENT_ID]:instrumentID,
        [PARAMS.BS]:isBuy? 'B':'S',
        [PARAMS.PRICE]: price,
        [PARAMS.QTY]:quantity
      }
    }
    this.setState({
      loading:true
    })
    this.props.getOrderFeesAction(params, res => {
      if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          feeAmt:res.result.feeAmt,
          feesList:res.result.feesList,
          loading:false
        })
      }else{
        this.setState({
          feeAmt:"-",
          feesList:[],
          loading:false
        })
      }
    })
  }

  isResubmitReasonTips = () => {
    const {isResubmitReasonList} = this.state;
    const isResubmitReasonTips = [];
    isResubmitReasonList.map((isResubmitReason, index) => {
      isResubmitReasonTips.push(<Tips key={index} type={tipsType.warning}>{isResubmitReason}</Tips>)
    })
    return isResubmitReasonTips;
  }

  componentDidMount() {
    this.mappingOrderData(this.props.data)
    this.getCommissionAndFees();
    const { language ,data} = this.props
    // if(language.title === 'zh_TW' || language.title === 'zh_CN'){
    //   if(data.instrumentChineseShortName){
    //     this.setState({
    //       stockName:data.instrumentChineseShortName
    //     })
    //   }else{
    //     this.setState({
    //       stockName:data.instrumentShortName
    //     })
    //   }
    // }else{
    //   this.setState({
    //     stockName:data.instrumentShortName
    //   })
    // }
    if(language.title === 'zh_TW' || language.title === 'zh_CN'){
      if(data.instrumentChineseName){
        this.setState({
          stockName:data.instrumentChineseName
        })
      }else{
        this.setState({
          stockName:data.instrumentName
        })
      }
    }else{
      this.setState({
        stockName:data.instrumentName
      })
    }
  }

  getTotalAmount(){
    const {data} = this.props;
    const {feeAmt} = this.state;
    let totalAmount = ''
    if(data.isModifyOrder === 'Y'){
      if(feeAmt && feeAmt != '-'){
        if(data.bs ==='B'){
          totalAmount = formatFunctions.dataFormat((Number(data.newPrice * data.newQTY) + Number(feeAmt)), dataType.CASH);
        }else{
          totalAmount = formatFunctions.dataFormat((Number(data.newPrice * data.newQTY) - Number(feeAmt)), dataType.CASH);
        }
      }else{
        totalAmount = formatFunctions.dataFormat(data.newPrice * data.newQTY, dataType.CASH);
      }
    }else{
      if(feeAmt && feeAmt != '-'){
        if(data.isBuy){
          totalAmount = formatFunctions.dataFormat((Number(data.price * data.quantity) + Number(feeAmt)), dataType.CASH);
        }else{
          totalAmount = formatFunctions.dataFormat((Number(data.price * data.quantity) - Number(feeAmt)), dataType.CASH);
        }
      }else{
        totalAmount = formatFunctions.dataFormat(data.price * data.quantity, dataType.CASH);
      }
    }
    return data.currencyID + ' ' + String(totalAmount);
  }

  render() {
    const { language, data, isMobile } = this.props
    const { isSend, orderTable, orderResult, stockName, isResubmitReasonList, loading, feeAmt, feesList  } = this.state
    return (
        <React.Fragment>
          {!isSend &&
          <div className="order-confirm-box" style={{ width: isMobile && '100%' }}>
            <LoadingLayer load={loading} type={LOADING_TYPE.BIG_IMG}/>
            {isResubmitReasonList.length > 0 && this.isResubmitReasonTips()}
            <b>
              <div className="order-confirm-title">
                {`${data.marketID}.${data.instrumentID ? data.instrumentID : data.stockCode} ${stockName ? stockName : '-'}`}
              </div>
              <div className={classnames("order-confirm-action-price", data.isBuy ? 'buy-color' : 'sell-color')}>
                <div>{getSafe(() => language[`${data.isBuy ? 'common_buy' : 'common_sell'}`])}</div>
                <div>{this.getTotalAmount()}</div>  
              </div>
            </b>
            <section>
              {orderTable.map(item =>
                  <div key={item.label}>
                    <span className='span-left'>{getSafe(() => language[item.label])}</span>
                    <span className='span-right'><b>{item.value}</b>
                  </span>
                  </div>
              )}
              <div>
                <span className='span-left'>
                  <div style={feesList.length>0 ? {cursor:'pointer',display:'inline-block',textDecoration:'underline'} : {display:'inline-block'}}
                    onClick={() => {if (feesList.length > 0) openOrderFeesDialog(feesList,data.currencyID,feeAmt)}}>
                    {getSafe(() => language.common_commission_fees)}
                  </div>
                </span>
                <span className='span-right'>
                  <b>{feeAmt ? data.currencyID + ' ' + formatFunctions.dataFormat(feeAmt,dataType.CASH) : '-'}</b>
                </span>
              </div>
            </section>
            {/* <div>
              <PIN />
            </div> */}
            <footer>
              <div style={{display:loading ? 'none' :'block'}}>
                <button className="cancel-btn"
                        onClick={() => this.closeDialog(false)}>{getSafe(() => language.common_cancel)}</button>
                <button className="confirm-btn"
                        onClick={this.handleConfirm}>{getSafe(() => language.common_confirm)}</button>
              </div>
            </footer>
          </div>
          }
          {isSend &&
          <OrderConfirmStatus
              orderData={data}
              orderResult={orderResult}
              onClose={this.closeDialog}
              mode={data.isModifyOrder === 'Y' ? ORDER_MODE.MODIFY:ORDER_MODE.CREATE}
          />
          }
        </React.Fragment>
    )
  }
}

export default connect(
    state => ({
      language: state.app.language,
      isMobile: state.app.isMobile,
      currentTradingAccount: state.trade.currentTradingAccount
    }),
    dispatch => ({
      placeOrderAction: (p, res) => dispatch(orderActions.placeOrderAction(p, res)),
      getOrderFeesAction: (p, res) => dispatch(orderActions.getOrderFeesAction(p, res)),
      modifyOrder: (p, res) => dispatch(orderActions.modifyOrderAction(p, res))
    })
)(OrderConfirm)